import { createAction } from 'redux-actions';
import { openGlobalModal } from 'actions/modal';

import { wrapFetchAuth } from './endpoint';
import { toggleLoading } from './global';


export const getCouponList = createAction('GET_COUPON_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/user/coupon', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			list: data,
		};
	}
	return {};
});

export const addCoupon = createAction('ADD_COUPON', number => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/coupon', {
		method: 'PUT',
		body: JSON.stringify({ number }),
	});
	dispatch(toggleLoading(false));

	if (result.status === 200) {
		dispatch(getCouponList());
	} else {
		dispatch(openGlobalModal('addCouponFail'));
	}
});



// WEBPACK FOOTER //
// ./src/actions/coupon.js